import { Picker } from 'emoji-mart'
import PropTypes from 'prop-types'
import { useRef, useState } from 'react'
import { doesSupportEmoji, setCaretPosition } from 'utils/helpers'

import { ReactComponent as EmojiIcon } from './emoji.svg'
import styles from './TextInput.module.scss'

const EmojiPicker = ({ show, className, winClassName, onSelect }) =>
  show ? (
    <div
      className={navigator.appVersion.indexOf('Win') !== -1 ? winClassName : className}
    >
      <Picker
        set="apple"
        onSelect={onSelect}
        showPreview={false}
        native={doesSupportEmoji()}
        showSkinTones={false}
        autoFocus={true}
      />
    </div>
  ) : null

const TextInputWithEmoji = ({
  type = 'text',
  label,
  className,
  valid,
  onValueChange,
  children,
  value,
  ...props
}) => {
  const [isEmojiPickerVisible, setIsEmojiPickerVisible] = useState(false)
  const [caretPos, setCaretPos] = useState(0)

  const inputRef = useRef()

  function handleClickEmojiButton(e) {
    e.preventDefault()
    setIsEmojiPickerVisible(s => !s)
    inputRef?.current?.focus()
  }

  function handleSelectEmoji(emoji) {
    setIsEmojiPickerVisible(false)
    onValueChange(
      [value.substring(0, caretPos), emoji.native, value.substring(caretPos)].join('')
    )

    setTimeout(() => {
      setCaretPosition(inputRef.current, caretPos + emoji.native.length)
    }, 10)
  }

  return (
    <label className={[styles.container, className ? className : ''].join(' ')}>
      {label && <span className={styles.label}>{label}</span>}
      <input
        className={[
          styles.input,
          valid === true ? styles.inputSuccess : '',
          valid === false ? styles.inputError : ''
        ].join(' ')}
        ref={inputRef}
        {...props}
        autoComplete="off"
        onBlur={e => setCaretPos(e.target.selectionStart)}
        type={type}
        onChange={e => onValueChange(e.target.value)}
        value={typeof value !== 'undefined' ? value : undefined}
      />
      <button
        type="button"
        onClick={handleClickEmojiButton}
        className={styles.buttonWithIcon}
      >
        <EmojiIcon />
      </button>
      <EmojiPicker
        show={isEmojiPickerVisible}
        onSelect={handleSelectEmoji}
        className={styles.emojiPicker}
        winClassName={styles.emojiPickerWin}
      />
      {children}
    </label>
  )
}

TextInputWithEmoji.propTypes = {
  label: PropTypes.string,
  className: PropTypes.string,
  succeded: PropTypes.bool,
  errored: PropTypes.bool
}

export default TextInputWithEmoji
